import React from 'react';
import en_US from "./en_US";
import zh_CN from "./zh_CN";

import {
    Button,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogActions,
} from '@material-ui/core';

const charsBase = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

let lookupBase = new Uint8Array(256);
for (let i = 0; i < charsBase.length; i++) {
    lookupBase[charsBase.charCodeAt(i)] = i;
}

function base64EncodeBase(arraybuffer) {
    let bytes = new Uint8Array(arraybuffer),
        i, len = bytes.length, base64 = "";

    for (i = 0; i < len; i += 3) {
        base64 += charsBase[bytes[i] >> 2];
        base64 += charsBase[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
        base64 += charsBase[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
        base64 += charsBase[bytes[i + 2] & 63];
    }

    if ((len % 3) === 2) {
        base64 = base64.substring(0, base64.length - 1) + "=";
    } else if (len % 3 === 1) {
        base64 = base64.substring(0, base64.length - 2) + "==";
    }

    return base64;
}

function base64DecodeBase(base64) {
    let bufferLength = base64.length * 0.75,
        len = base64.length, i, p = 0,
        encoded1, encoded2, encoded3, encoded4;

    if (base64[base64.length - 1] === "=") {
        bufferLength--;
        if (base64[base64.length - 2] === "=") {
            bufferLength--;
        }
    }

    let arraybuffer = new ArrayBuffer(bufferLength),
        bytes = new Uint8Array(arraybuffer);

    for (i = 0; i < len; i += 4) {
        encoded1 = lookupBase[base64.charCodeAt(i)];
        encoded2 = lookupBase[base64.charCodeAt(i + 1)];
        encoded3 = lookupBase[base64.charCodeAt(i + 2)];
        encoded4 = lookupBase[base64.charCodeAt(i + 3)];

        bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
        bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
        bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
    }

    return arraybuffer;
}

const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";

let lookup = new Uint8Array(256);
for (let i = 0; i < chars.length; i++) {
    lookup[chars.charCodeAt(i)] = i;
}

function base64Encode(arraybuffer) {
    let bytes = new Uint8Array(arraybuffer),
        i, len = bytes.length, base64 = "";

    for (i = 0; i < len; i += 3) {
        base64 += chars[bytes[i] >> 2];
        base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
        base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
        base64 += chars[bytes[i + 2] & 63];
    }

    if ((len % 3) === 2) {
        base64 = base64.substring(0, base64.length - 1) + "=";
    } else if (len % 3 === 1) {
        base64 = base64.substring(0, base64.length - 2) + "==";
    }

    return base64;
}

function base64Decode(base64) {
    let bufferLength = base64.length * 0.75,
        len = base64.length, i, p = 0,
        encoded1, encoded2, encoded3, encoded4;

    if (base64[base64.length - 1] === "=") {
        bufferLength--;
        if (base64[base64.length - 2] === "=") {
            bufferLength--;
        }
    }

    let arraybuffer = new ArrayBuffer(bufferLength),
        bytes = new Uint8Array(arraybuffer);

    for (i = 0; i < len; i += 4) {
        encoded1 = lookup[base64.charCodeAt(i)];
        encoded2 = lookup[base64.charCodeAt(i + 1)];
        encoded3 = lookup[base64.charCodeAt(i + 2)];
        encoded4 = lookup[base64.charCodeAt(i + 3)];

        bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
        bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
        bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
    }

    return arraybuffer;
}

function decodeBrotliUrl(data) {
    data = base64Decode(data);
    let decompress = require('brotli/decompress');
    data = decompress(new Buffer(data));
    return new TextDecoder("utf-8").decode(data);
}

function decodeQuery(name) {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    let r = window.location.search.substr(1).match(reg);
    if (r != null) {
        return decodeURI(r[2]);
    }
    return null;
}

function isWeiXin() {
    let ua = navigator.userAgent.toLowerCase();
    return ua.match(/MicroMessenger/i);
}

function isWin() {
    return (navigator.platform === "Win32") || (navigator.platform === "Windows");
}

function isWebpSupport() {
    const canvas = document.createElement('canvas');
    if (Boolean(canvas.getContext && canvas.getContext('2d'))) {
        return canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0;
    }
    return false;
}

function chooseLocale() {
    if (navigator.language.startsWith('zh')) {
        return zh_CN;
    }
    return en_US;
}

class WeiXinWinBoardErrorHintDialog extends React.Component {

    state = {
        open: isWeiXin() && isWin(),
    };

    handleClose = () => {
        this.setState({open: false});
    };

    render() {
        return (
            <Dialog
                open={this.state.open}
                onClose={this.handleCloseDialog}
                scroll='paper'
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" style={{whiteSpace: 'pre-line'}}>
                        {'在微信pc版自带浏览器中棋盘可能会渲染不正确，请点击左上方“用默认浏览器打开”按钮来浏览网页。'}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose} color="primary" autoFocus>
                        知道了
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export {
    base64EncodeBase,
    base64DecodeBase,
    base64Encode,
    base64Decode,
    decodeBrotliUrl,
    decodeQuery,
    isWeiXin,
    isWebpSupport,
    chooseLocale,
    WeiXinWinBoardErrorHintDialog,
};



// WEBPACK FOOTER //
// ./src/utils.js